import React from "react";

const SmallButton = ({ onClick, className = "", children }) => (
  <button
    onClick={onClick}
    className={`px-1 sm:px-2 py-0.5 sm:py-1 text-xs sm:text-sm font-medium 
    text-purple-600 dark:text-purple-400
    hover:text-purple-700 dark:hover:text-purple-300 
    transition-colors ${className}`}
  >
    {children}
  </button>
);

const InputWithMax = ({ value, onChange, placeholder, onMaxClick }) => (
  <div className="relative flex items-center w-full max-w-sm lg:max-w-md">
    <input
      type="text"
      className="flex-1 px-2 sm:px-4 py-1.5 sm:py-2 text-sm sm:text-base
        rounded-lg sm:rounded-xl border border-gray-200 dark:border-gray-600 
        bg-transparent pr-12 sm:pr-16
        focus:outline-none focus:ring-1 focus:ring-purple-500
        placeholder:text-gray-400 dark:placeholder:text-gray-500"
      placeholder={placeholder}
      value={value}
      onChange={onChange}
    />
    <SmallButton
      className="absolute right-1 sm:right-2"
      onClick={onMaxClick}
    >
      Max
    </SmallButton>
  </div>
);

export default InputWithMax;
